import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef
} from '@angular/core';
import { LayoutPortalService } from '@core/portals/layout-portal.service';
import { Subscription } from 'rxjs';
import { unsubscribeAll } from '@common/utils/rxjs-utils';

@Component({
    selector: 'e-portal',
    templateUrl: './e-portal.component.html',
    styleUrls: ['./e-portal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class EPortalComponent implements OnInit, OnDestroy {
  @Input() key: string | symbol;

  constructor(
    private readonly portalService: LayoutPortalService,
    private readonly changeDetection: ChangeDetectorRef
  ) {}

  private readonly subscriptions: Subscription[] = [];

  get portal(): TemplateRef<HTMLElement> | undefined {
    return this.portalService.getPortal(this.key);
  }

  ngOnInit(): void {
    this.subscriptions.push(
      this.portalService.update$.subscribe(() => {
        this.changeDetection.markForCheck();
      })
    );
  }

  ngOnDestroy(): void {
    unsubscribeAll(this.subscriptions);
  }
}
